// DraftJS stuff
import "draft-js/dist/Draft.css";
import "@draft-js-plugins/anchor/lib/plugin.css";
import "@draft-js-plugins/counter/lib/plugin.css";
import "@draft-js-plugins/linkify/lib/plugin.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import "@draft-js-plugins/focus/lib/plugin.css";
// -- DraftJS stuff end.
import DefaultTextEditor from "components/TextEditors/DefaultTextEditor";
import { EditorState, convertToRaw } from "draft-js";

const EmptyRawEditorState = convertToRaw(
  EditorState.createEmpty().getCurrentContent()
);

// note: always import the text editors in the following form:
// import { DefaultTextEditor } from "components/TextEditors";
// this ensures that the extra styles get loaded
export { DefaultTextEditor, EmptyRawEditorState };
